module.exports = __webpack_public_path__ + "static/media/06.11c79a72.wav";